(function() {

/**
 * Static methods to operate on Javascript Date objects
 * FIXME: make activity center use this, not its own version
 * @module base
 * @class DateExt
 * @namespace rwgps
 */
  module.exports = {
    DateExt: {
      /** Parse ISO8601 datetime string (e.g. 2010-07-26T17:20:01-07:00)
       * @method parse
       * @static
       * @param {String} dateStr ISO8601 datetime string
       * @return {Date} Javascript Date object
       */
      parse: function(dateStr, disableUserLocale) {
        if(!dateStr) return;
        if(disableUserLocale === undefined)
          disableUserLocale = false;
        dateStr = dateStr.replace("Z", "-00:00");
        var dateParts = dateStr.match(/^([0-9]{4})-0?([0-9]{1,2})-0?([0-9]{1,2})T0?([0-9]{1,2}):0?([0-9]{1,2}):0?([0-9]{1,2})([-+])0?([0-9]{1,2}):0?([0-9]{1,2})$/),
        year = parseInt(dateParts[1]),
        month = parseInt(dateParts[2]) - 1, // javascript dates use 0-based months
        day = parseInt(dateParts[3]),
        hours = parseInt(dateParts[4]),
        minutes = parseInt(dateParts[5]),
        seconds = parseInt(dateParts[6]),
        offsetSign = dateParts[7],
        offsetHours = parseInt(dateParts[8]),
        offsetMinutes = parseInt(dateParts[9]),
        offsetMilliseconds = (offsetSign == '-' ? 1 : -1) * (offsetHours * 60 + offsetMinutes) * 60000;
        
        var date = new Date();
        if(disableUserLocale) {
          date.setFullYear(year, month, day);
          date.setHours(hours, minutes, seconds);
        } else {
          date.setUTCFullYear(year, month, day);
          date.setUTCHours(hours, minutes, seconds);
          date.setTime( date.getTime() + offsetMilliseconds );
        }

        return date;
      },
      /** Parse YYYY-MM-DD date string
       * @method parseDate
       * @static
       * @param {String} dateStr Date represented as string in format YYYY-MM-DD
       * @return {Date} Javascript Date object
       */
      parseDate: function(dateStr) {
        if(!dateStr) return;
        var dateParts = dateStr.match(/^([0-9]{4})-0?([0-9]{1,2})-0?([0-9]{1,2})$/),
        year = parseInt(dateParts[1]),
        month = parseInt(dateParts[2]) - 1, // javascript dates use 0-based months
        day = parseInt(dateParts[3]);
        
        var date = new Date(year, month, day);

        return date;
      }
    }
  };
})();



// WEBPACK FOOTER //
// ./public/javascripts/rwgps/date_ext.js